import { useMemo } from "react";
import moment from "moment";
import { BigNumber } from "@ethersproject/bignumber";
import { getAssets, getVaultChain, isPutVault, } from "../constants/constants";
import { getAssetDecimals } from "../utils/asset";
import useVaultActivity from "./useVaultActivity";
import { assetToFiat, formatOptionStrike } from "../utils/math";
import { useAssetsPrice } from "./useAssetPrice";
import { formatUnits } from "@ethersproject/units";
export var useLatestOption = function (vaultOption, vaultVersion) {
    var asset = getAssets(vaultOption);
    var _a = useVaultActivity(vaultOption, vaultVersion), activities = _a.activities, activityLoading = _a.loading;
    var prices = useAssetsPrice().prices;
    var chain = getVaultChain(vaultOption);
    var optionHistory = useMemo(function () {
        var sortedActivities = activities
            .filter(function (activity) { return activity.type === "minting"; })
            .sort(function (a, b) { return (a.date.valueOf() < b.date.valueOf() ? 1 : -1); });
        if (sortedActivities.length <= 0) {
            return [];
        }
        return sortedActivities.map(function (_shortPosition) {
            var shortPosition = _shortPosition;
            var optionTraded = activities.filter(function (activity) {
                return activity.type === "sales" &&
                    activity.vaultShortPosition.id === shortPosition.id;
            });
            var decimals = getAssetDecimals(asset);
            var isPut = isPutVault(vaultOption);
            return {
                strike: shortPosition.strikePrice,
                expiry: moment(shortPosition.expiry, "X"),
                premium: optionTraded.reduce(function (acc, curr) { return acc.add(curr.premium); }, BigNumber.from(0)),
                depositAmount: shortPosition.depositAmount,
                amount: isPut
                    ? parseFloat(assetToFiat(shortPosition.depositAmount, prices[asset].price, decimals)) / formatOptionStrike(shortPosition.strikePrice, chain)
                    : parseFloat(formatUnits(shortPosition.depositAmount, decimals)),
                isPut: isPut,
                loading: activityLoading || prices[asset].loading,
            };
        });
    }, [activities, asset, vaultOption, prices, chain, activityLoading]);
    return {
        option: optionHistory.length > 0 ? optionHistory[0] : undefined,
        optionHistory: optionHistory,
    };
};
//# sourceMappingURL=useLatestOption.js.map